export const route = {
    INITIAL: "/",
    home: {
        HOME1: "/",
        HOME2: "/index2",
        HOME3: "/index3"
    },
    pages: {
        ABOUT: "/about-us",
        FAQ: "/faq",
        FEATURE: "/features",
        team: {
            TEAM: "/team",
            DETAIL: "/team/detail"
        },
        contact: {
            CONTACT1: "/contact",
            CONTACT2: "/contact-us2",
            GET_QUOTE: "/get-quote"
        },
        gallery: {
            GALLERY1: "/gallery",
            GALLERY2: "/gallery"
        },
        ERROR404: "/error404",
        features: {
            footer: {
                FIXED: "/footer/fixed",
                LIGHT: "/footer/light",
                DARK: "/footer/dark"
            }
        }
    },
    services: {
        SERVICES: "/services",
        DETAIL: "/service/detail"
    },
    blog: {
        LIST: "/blog/list",
        LIST_SIDEBAR: "/blog/list-sidebar",
        GRID: "/blog/grid",
        GRID_SIDEBAR: "/blog/grid-sidebar",
        POST_SINGLE: "/blog/post-single",
        DETAIL: "/blog/:id",
        getDetailUrl: (id) => `/blog/${id}`
    },
    shop: {
        PRODUCTS: "/shop/products",
        DETAIL: "/shop/detail",
        CART: "/shop/cart",
        WISHLIST: "/shop/wishlist",
        CHECKOUT: "/shop/checkout"
    },
    ELEMENTS: "/elements",
    customer: {
        LOGIN: "/login"
    },
    admin: {
        LOGIN: "/admin",
        DASHBOARD: "/admin/dashboard",
        MESSAGES: "/admin/messages",
        BLOG_LIST: "/admin/blogs",
        BLOG_CREATE: "/admin/blogs/new",
        BLOG_EDIT: "/admin/blogs/:id/edit",
        getBlogEditUrl: (id) => `/admin/blogs/${id}/edit`,
        GALLERY_LIST: "/admin/gallery",
        GALLERY_MANAGE: "/admin/gallery/manage",
        GALLERY_CREATE: "/admin/gallery/manage",
        getGalleryEditUrl: (id) => `/admin/gallery/${id}/edit`
    }
}

export function publicUrlFor(path) {
    if (!path) {
        return "";
    }

    const trimmed = path.trim();
    if (
        trimmed.startsWith('/') ||
        trimmed.startsWith('http://') ||
        trimmed.startsWith('https://') ||
        trimmed.startsWith('data:')
    ) {
        return trimmed;
    }

    return (process.env.PUBLIC_URL || "") + "/assets/" + trimmed;
}

export function loadScript(src, fromPublic) {

    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');

        script.src = (
            fromPublic === undefined ||
            fromPublic == null ||
            fromPublic
        ) ? publicUrlFor(src) : src;

        script.addEventListener('load', function () {
            resolve();
        });
        script.addEventListener('error', function (e) {
            reject(e);
        });

        setTimeout(() => {
            document.body.removeChild(script);
        }, 1500);
        document.body.appendChild(script);
    })
};